import { useState } from 'react';
import { Route, Switch } from 'react-router';
import { Link, NavLink } from 'react-router-dom';
import ChatBot from './components/ChatBot';
import { Deposit } from './components/Deposit';
import FundTransfer from './components/FundTransfer';
import Getotp from './components/Getotp';
import { Home } from './components/Home';
import Insurance from './components/Insurance';
import Login from './components/Login';
import ViewBalance from './components/ViewBalance';
import { ViewStatement } from './components/ViewStatement';
import home from './img/home.png';
import log from './img/logout.png';
import axios from 'axios';

function App() {
  const [auth, setAuth] = useState(0);
  
  function handleChange(newValue) {
    setAuth(newValue);
  }
  
  const removeDetails = async () => {
    try {
      const res = await axios.get("http://localhost:5001/logout");
      console.log("loggedOut", res);
      setAuth(0);
    } catch (error) {
      console.error("Logout error:", error);
      setAuth(0);
    }
  }

  if (!auth) {
    return <Login auth={auth} onChange={handleChange} />;
  }

  return (
    <div className="App">
      {/* Modern Navigation */}
      <nav>
        <div className="nav-brand">
          <img src={home} alt="Bank Logo" width="30" height="30" />
          <span>Aurora Bank</span>
        </div>
        <div className="nav-links">
          <NavLink activeClassName='active' to='/ChangePIN'>Change PIN</NavLink> 
          <NavLink activeClassName='active' to='/FundsTransfer'>Transfer Funds</NavLink>
          <NavLink activeClassName='active' to='/Balance'>Balance</NavLink>
          <NavLink activeClassName='active' to='/Insurance'>Insurance</NavLink>
          <NavLink activeClassName='active' to='/Transactions'>Transactions</NavLink>
          <NavLink activeClassName='active' to='/Deposits'>Deposit</NavLink>
        </div>
      </nav>

      {/* Main Content */}
      <main className="main-content">
        <Switch>
          <Route path="/ChangePIN">
            <Getotp />
          </Route>
          <Route path="/FundsTransfer">
            <FundTransfer />
          </Route>
          <Route path="/Balance">
            <ViewBalance />
          </Route>
          <Route path="/Insurance">
            <Insurance />
          </Route>
          <Route path="/Transactions">
            <ViewStatement />
          </Route>
          <Route path="/Deposits">
            <Deposit />
          </Route>
          <Route path="/Home">
            <Home />
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
      </main>

      {/* Floating Action Buttons */}
      <div className="floating-actions">
        <Link to='/Home' className="fab">
          <img src={home} alt='Home' />
        </Link>
        <button className="fab logout-btn" onClick={removeDetails}>
          <img src={log} alt='Logout' />
        </button>
      </div>

      {/* ChatBot Widget - Always Present */}
      <ChatBot />
    </div>
  );
}

export default App;
